import { render } from "./AppModal.vue?vue&type=template&id=70c58bdd"
const script = {}

import "./AppModal.vue?vue&type=style&index=0&id=70c58bdd&lang=scss"

import exportComponent from "/Users/jonasmaersk/Documents/GitHub/ski-scanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__